(() => {
  if (window.fmProductPageListenersReady) return;
  window.fmProductPageListenersReady = true;

  const showRequiredSizeError = select => {
    const wrapper = select?.closest('.product-form__input--dropdown');
    if (!wrapper) return;
    wrapper.classList.add('error');
    let message = wrapper.querySelector('.js-size-error-msg');
    if (!message) {
      message = document.createElement('div');
      message.className = 'js-size-error-msg';
      message.setAttribute('role', 'alert');
      message.textContent = select.dataset.error || 'Please select a size.';
      wrapper.append(message);
    }
    select.focus();
    select.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  };
  const updatePartialFrameSummary = (frameControl, picker) => {
    const frameWrapper = frameControl.closest('.fm-artwork-frame-options[data-option-index]');
    const frameLabel = frameWrapper?.querySelector('.form__label .font-medium');
    if (frameLabel) frameLabel.textContent = frameControl.value;

    const optionIndex = Number((frameWrapper?.dataset.optionIndex || '').replace('option', ''));
    const variants = JSON.parse(picker?.querySelector('[data-variants]')?.textContent || '[]');
    const matches = variants.filter(variant => variant.available && variant[`option${optionIndex}`] === frameControl.value);
    if (!matches.length) return;

    const lowestPrice = Math.min(...matches.map(variant => variant.price));
    const hasPriceRange = new Set(matches.map(variant => variant.price)).size > 1;
    const format = theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
    const price = frameControl.closest('.fm-artwork-product')?.querySelector('.fm-artwork-product__price .price__regular, .product__price .price__regular');
    if (price) price.textContent = `${hasPriceRange ? 'From ' : ''}${theme.Currency.formatMoney(lowestPrice, format)}`;
  };
  // Frame is a partial choice. Do not let the native variant picker resolve it
  // to the first matching variant while the required Size select is still blank.
  // The checked frame remains visible; the next Size change submits both choices.
  document.addEventListener('change', event => {
    const frameControl = event.target.closest('.fm-artwork-product .fm-artwork-frame-options input[type="radio"]');
    if (!frameControl?.checked) return;
    const picker = frameControl.closest('.fm-artwork-mixed-picker');
    const sizeSelect = picker?.querySelector('[data-fm-size-required]');
    if (!sizeSelect || sizeSelect.value) return;
    updatePartialFrameSummary(frameControl, picker);
    event.stopPropagation();
  }, true);
  document.addEventListener('change', event => {
    const variantControl = event.target.closest('.fm-artwork-product .fm-artwork-mixed-picker select, .fm-artwork-product .fm-artwork-mixed-picker input[type="radio"]');
    if (variantControl && (variantControl.tagName === 'SELECT' || variantControl.checked)) {
      const wrapper = variantControl.closest('[data-option-index]');
      const selectedLabel = wrapper?.querySelector('.form__label .font-medium');
      if (selectedLabel && variantControl.value) selectedLabel.textContent = variantControl.value;
    }

    if (!event.target.matches('.fm-artwork-product [data-fm-size-required]')) return;
    const wrapper = event.target.closest('.product-form__input--dropdown');
    wrapper?.classList.remove('error');
    wrapper?.querySelector('.js-size-error-msg')?.remove();
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.fm-artwork-product button[name="add"],.fm-artwork-product .product-form__submit,.fm-artwork-product .shopify-payment-button');
    if (!trigger) return;
    const root = trigger.closest('.fm-artwork-product');
    const select = root?.querySelector('[data-fm-size-required]');
    if (!select || select.value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showRequiredSizeError(select);
  }, true);
  document.addEventListener('submit', event => {
    const root = event.target.closest('.fm-artwork-product');
    const select = root?.querySelector('[data-fm-size-required]');
    if (!select || select.value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showRequiredSizeError(select);
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-fm-product-help-drawer]');
    if (!trigger) return;
    const drawer = document.getElementById('HelpDrawer');
    const source = document.getElementById(trigger.dataset.fmHelpContentId);
    const title = drawer?.querySelector('.drawer__title');
    const scrollable = drawer?.querySelector('.drawer__scrollable');
    if (!drawer || !source || !title || !scrollable) return;

    const originalTitle = title.textContent;
    const originalChildren = [...scrollable.children].map(node => ({ node, hidden: node.hidden }));
    const oldPanel = scrollable.querySelector('[data-fm-product-help-panel]');
    oldPanel?.remove();
    originalChildren.forEach(({ node }) => { node.hidden = true; });

    title.textContent = trigger.dataset.fmHelpTitle || originalTitle;
    const panel = document.createElement('div');
    panel.className = 'rte text-base';
    panel.dataset.fmProductHelpPanel = '';
    panel.append(source.content.cloneNode(true));
    scrollable.append(panel);

    drawer.addEventListener('drawer:afterHide', () => {
      panel.remove();
      originalChildren.forEach(({ node, hidden }) => { node.hidden = hidden; });
      title.textContent = originalTitle;
    }, { once: true });
  }, true);
  document.addEventListener('click', event => {
    const image = event.target.closest('.fm-artwork-product [data-media-type="image"] img');
    if (!image) return;
    const trigger = image.closest('[data-media-type="image"]')?.querySelector('button[is="media-lightbox-button"]');
    if (!trigger) return;
    event.preventDefault();
    trigger.click();
  }, true);
  class PdpTabs extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = [...this.querySelectorAll('.pdp-tab-button')];
      this.headers = [...this.querySelectorAll('.pdp-accordion-header')];
      this.panels = [...this.querySelectorAll('.pdp-content-panel')];
      this.mobileQuery = matchMedia('(max-width: 768px)');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectDesktop(index), { signal });
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.selectDesktop(next); this.tabs[next].focus();
        }, { signal });
      });
      this.headers.forEach((header, index) => {
        header.addEventListener('click', () => this.toggleMobile(index), { signal });
      });
      this.mobileQuery.addEventListener('change', () => this.syncLayout(), { signal });
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.contains(event.target) || panel.previousElementSibling?.contains(event.target));
        if (index < 0) return;
        if (this.mobileQuery.matches) this.openMobile(index);
        else this.selectDesktop(index);
      }, { signal });
      this.syncLayout();
    }
    syncLayout() {
      const selectedIndex = Math.max(0, this.tabs.findIndex(tab => tab.classList.contains('pdp-active')));
      if (this.mobileQuery.matches) this.openMobile(selectedIndex);
      else this.selectDesktop(selectedIndex);
    }
    selectDesktop(index) {
      this.tabs.forEach((tab, itemIndex) => {
        const active = itemIndex === index;
        tab.classList.toggle('pdp-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[itemIndex]?.classList.toggle('pdp-active', active);
        this.panels[itemIndex]?.toggleAttribute('hidden', !active);
      });
    }
    openMobile(index) {
      this.headers.forEach((header, itemIndex) => {
        const active = itemIndex === index;
        header.classList.toggle('pdp-active', active);
        header.setAttribute('aria-expanded', String(active));
        this.panels[itemIndex]?.classList.toggle('pdp-active', active);
        this.panels[itemIndex]?.toggleAttribute('hidden', !active);
      });
    }
    toggleMobile(index) {
      const header = this.headers[index];
      const wasActive = header.classList.contains('pdp-active');
      const top = header.getBoundingClientRect().top;
      this.headers.forEach((item, itemIndex) => {
        item.classList.remove('pdp-active');
        item.setAttribute('aria-expanded', 'false');
        this.panels[itemIndex]?.classList.remove('pdp-active');
        this.panels[itemIndex]?.setAttribute('hidden', '');
      });
      if (!wasActive) this.openMobile(index);
      requestAnimationFrame(() => window.scrollBy({ top: header.getBoundingClientRect().top - top, behavior: 'auto' }));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  if (!customElements.get('fm-pdp-tabs')) customElements.define('fm-pdp-tabs', PdpTabs);
  class ArtworkDetails extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.rows = [...this.querySelectorAll('.fm-artwork-details__row')];
      this.tabs = this.querySelector('[role="tablist"]');
      if (!this.rows.length || !this.tabs) return;
      this.tabs.replaceChildren();
      this.tabs.setAttribute('aria-label', this.dataset.label || 'Artwork details');
      this.buttons = this.rows.map((row, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.role = 'tab';
        button.id = row.id + '-tab'; button.textContent = row.querySelector('summary').firstChild.textContent.trim();
        button.setAttribute('aria-controls', row.id);
        button.addEventListener('click', () => this.select(index), { signal });
        button.addEventListener('keydown', event => {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.rows.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.rows.length) % this.rows.length;
          this.select(next); this.buttons[next].focus();
        }, { signal });
        this.tabs.append(button); return button;
      });
      this.media = matchMedia('(min-width: 768px)');
      this.onMedia = () => this.layout();
      this.media.addEventListener('change', this.onMedia);
      this.addEventListener('shopify:block:select', event => {
        const index = this.rows.findIndex(row => row.contains(event.target));
        if (index >= 0) { this.select(index); this.rows[index].open = true; }
      }, { signal });
      this.layout();
    }
    layout() {
      const desktop = this.media.matches;
      this.tabs.hidden = !desktop; this.toggleAttribute('data-tabs-ready', desktop);
      this.rows.forEach(row => {
        row.open = true;
        if (desktop) { row.setAttribute('role', 'tabpanel'); row.setAttribute('aria-labelledby', row.id + '-tab'); }
        else { row.removeAttribute('role'); row.removeAttribute('aria-labelledby'); }
      });
      if (desktop) this.select(this.index || 0);
    }
    select(index) {
      this.index = index;
      this.rows.forEach((row, i) => {
        row.open = i === index;
        this.buttons[i].setAttribute('aria-selected', String(i === index));
        this.buttons[i].tabIndex = i === index ? 0 : -1;
      });
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.media?.removeEventListener('change', this.onMedia);
    }
  }
  if (!customElements.get('fm-artwork-details')) customElements.define('fm-artwork-details', ArtworkDetails);
})();

(() => {
  if (customElements.get('fm-loop-countdown')) return;

  class LoopCountdown extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.start = Date.parse(this.dataset.start || '');
      this.duration = this.parseDuration(this.dataset.duration);
      if (!Number.isFinite(this.start) || this.duration <= 0) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      this.units = Object.fromEntries(
        [...this.querySelectorAll('[data-fm-loop-unit]')].map((node) => [node.dataset.fmLoopUnit, node])
      );
      this.accessible = this.querySelector('[data-fm-loop-accessible]');
      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    parseDuration(value) {
      const units = { d: 86400000, h: 3600000, m: 60000, s: 1000 };
      return [...String(value || '').toLowerCase().matchAll(/(\d+)\s*([dhms])/g)]
        .reduce((total, match) => total + Number(match[1]) * units[match[2]], 0);
    }

    tick() {
      const elapsed = Date.now() - this.start;
      const phase = ((elapsed % this.duration) + this.duration) % this.duration;
      const totalSeconds = Math.max(1, Math.ceil((this.duration - phase) / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const values = { days, hours, minutes, seconds };

      Object.entries(values).forEach(([key, value]) => {
        const unit = this.units[key];
        if (!unit) return;
        if (key === 'days') unit.hidden = value === 0;
        unit.querySelector('[data-fm-loop-value]').textContent = key === 'days' ? String(value) : String(value).padStart(2, '0');
      });

      const minuteKey = `${days}-${hours}-${minutes}`;
      if (this.accessible && this.minuteKey !== minuteKey) {
        this.minuteKey = minuteKey;
        this.accessible.textContent = `${days ? `${days} days ` : ''}${hours} hours ${minutes} minutes remaining`;
      }
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('fm-loop-countdown', LoopCountdown);
})();
